import { useQuery } from '@tanstack/react-query'
import request from 'api'
import axios from 'axios'
import { countryCode, languageCode } from 'utils/i18n'

const QUERY_KEYS = ['/services/samsung']

type PackageResponse = {
  packageName: string
  action: string
  iconUrl: string
  priority: number
  eventId: number
  title: string
  description: string
  appKey: string
  pnIntegrated: boolean
}

export type ConnectedServiceResponse = {
  clientId: string
  aliasName: string
}

export enum ServiceType {
  SERVICE = 1,
  APP = 2
}

export type SamsungService = {
  applicationId: string
  title: string
  description: string
  iconUrl: string
  action: string
  type: ServiceType
  connected: boolean
}

const fetcher = async () => {
  // todo : applicationRegion should be geographic location.
  const applicationRegion = countryCode
  const provider = undefined

  const [packageResponses, connectedServiceResponses] = await Promise.all([
    axios
      .get<PackageResponse[]>(
        `${process.env.REACT_APP_CONSENT_API_URL}/v1/package?platform=web&applicationRegion=${applicationRegion}&provider=${provider}&language=${languageCode}&region=${countryCode}`,
        {
          headers: {
            'x-os-version': 'WEB',
            'x-package-name': `${process.env.REACT_APP_NAME}`,
            'x-package-version': `${process.env.REACT_APP_VERSION}`,
            'x-model-name': 'browser',
            'x-started': String(Math.trunc(new Date().getTime() / 1000)),
            'x-requested': String(Math.trunc(new Date().getTime() / 1000)),
            'x-app-id': `${process.env.REACT_APP_CONSENT_APP_KEY}`
          }
        }
      )
      .then((res) => {
        if (!res.data) {
          throw new Error('EmptyResponse')
        }
        return res.data
      })
      .catch(() => [] as PackageResponse[]),
    request
      .get<ConnectedServiceResponse[]>(`/v1/services/samsung`)
      .then((res) => res.data)
      .catch(() => [] as ConnectedServiceResponse[])
  ])

  const services = packageResponses.map((pkg) => {
    return {
      applicationId: pkg.appKey,
      title: pkg.title,
      description: pkg.description,
      iconUrl: pkg.iconUrl,
      // action: pkg.action, // package action has deeplink which not support yet from web
      action: '',
      type: pkg.pnIntegrated ? ServiceType.SERVICE : ServiceType.APP,
      connected: false
    } as SamsungService
  })

  connectedServiceResponses.forEach((serviceResponse) => {
    const service = services.find((appService) => appService.applicationId === serviceResponse.clientId)
    if (service === undefined) {
      return
    }
    service.connected = true
  })

  return services
}

const useSamsungServicesQuery = () => useQuery(QUERY_KEYS, fetcher)

export default useSamsungServicesQuery
